import React from "react";
import { Box, Container, Typography, Button, Paper } from "@mui/material";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { useNavigate } from "react-router-dom";
import { endSession } from "../session";
import { ACCOUNT_STATUS_COPY } from "./moderation";

const AccountSuspended = ({ status }) => {
  const navigate = useNavigate();
  const copy = ACCOUNT_STATUS_COPY[status] || ACCOUNT_STATUS_COPY.suspended;

  const handleLogout = async () => {
    await endSession();
    navigate("/login");
  };

  return (
    <Container maxWidth="xs" sx={{ mt: "20vh" }}>
      <Paper sx={{ p: 4, textAlign: "center" }} variant="outlined">
        <GppMaybeIcon color="error" sx={{ fontSize: 56, mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          {copy.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {copy.body}
        </Typography>
        <Box>
          <Button variant="contained" fullWidth onClick={handleLogout}>
            Cerrar sesión
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default AccountSuspended;
